module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.type.fields.Title_fr))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.currentCards), function(card) {
    return _c('div', {
      key: card.id,
      staticClass: "card"
    }, [_c('Card', {
      attrs: {
        "card-info": card.fields,
        "add-or-remove": "add"
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535f6030","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/type-row.vue
// module id = P6XW
// module chunks = 1